export default {
  healthCheck: {
    header: {
      feature: "Sms compliance health check",
      heading: "Here's how your SMS consent collection is being kept compliant",
      description:
        "Your SMS Compliance Health Check shows the results of the daily checks Dataships runs to ensure SMS consent is collected compliantly. The current status is shown below and you can click 'Health Check History' in the sidebar to see a detailed breakdown of past checks.",
    },
    wordingComplianceCheck: "Wording Compliance Check",
    availabilityCheck: "Availability Check",
    doubleOptInCheck: "Double Opt-in Enabled Check",
    singleOptIn: {
      topContent: "Single Opt-in:",
      optInTitle: "1. Opt-in wording:",
      privacyPolicy: {
        title: "2. Privacy policy:",
        linkTitle: "Privacy Policy URL",
      },
      termsOfService: {
        title: "3. Terms of Service:",
        linkTitle: "Terms of Service URL",
      },
    },
    doubleOptIn: {
      topContent: "Double Opt-in:",
      requestSmsTitle: "4. Double Opt-in sms wording:",
      smsList: {
        title: "5. SMS list",
        subscribersLink: "SMS Subscribers list ({{ listId }})",
      },
      phoneNumbers: {
        title: "6. Phone numbers:",
        tableHeaders: {
          country: "Country",
          status: "Status",
        },
        active: "Active",
        inactive: "Inactive",
      },
    },
    historyCta: "See Full History",
    error:
      "Oops! Something has gone wrong fetching your Sms Health Check. Please try again.",
  },
  healthCheckHistory: {
    header: {
      feature: "SMS Compliance Health Check History",
      heading: "Here's your full history of SMS consent collection compliance",
    },
    tabs: {
      shopify: "Shopify",
      klaviyo: "Klaviyo",
    },
    shopify: {
      header: {
        heading: "Keeping your Shopify SMS consent collection compliant",
        description:
          "Every day we run 5 different automated compliance checks on your Shopify store's Checkout to determine your SMS consent collection compliance. Below is a full day by day breakdown of the results since you started collecting compliantly with Dataships.",
      },
      table: {
        columns: {
          date: "Date",
          optInWording: "Opt in: Wording",
          privacyPolicyWording: "Privacy Policy: Wording",
          privacyPolicyAvailability: "Privacy Policy: Availability",
          termsOfServiceWording: "Terms of Service: Wording",
          termsOfServiceAvailability: "Terms of Service: Availability",
        },
      },
    },
    klaviyo: {
      header: {
        heading: "Keeping your Klaviyo SMS consent collection compliant",
        description:
          "Every day we run 2 different automated compliance checks on your store's Klaviyo to determine your SMS consent collection compliance. Below is a full day by day breakdown of the results since you started collecting compliantly with Dataships.",
      },
      table: {
        columns: {
          date: "Date",
          request: "Double Opt-in Request SMS: Wording",
          smsList: "SMS List: Double Opt-in Enabled",
        },
      },
    },
  },
};
